import React from "react";
import Navbar from "layout/Navbar";

const MainLayout = (props) => {
  const { children } = props;

  return (
    <div className="layout layout-main">
      <Navbar />
      <div className="body p-4 bg-light">{children}</div>
    </div>
  );
};

export default MainLayout;
